import { Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import Input from "../../../../../component/input";

interface DrivingInstructors66Props {
  formik: any;
}

const DrivingInstructors66: React.FC<DrivingInstructors66Props> = ({
  formik,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={6} sm={6} lg={6}>
          <b>Description</b>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <b>Price</b>
        </Grid>

        <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>6/6 with certificate</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="drivingCertificatePrice"
                value={formik.values.drivingCertificatePrice}
                onChange={formik.handleChange}
              />
              {formik.touched.drivingCertificatePrice &&
                formik.errors.drivingCertificatePrice && (
                  <Typography className="error">
                    {formik.errors.drivingCertificatePrice}
                  </Typography>
                )}
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DrivingInstructors66;
